module.exports = __webpack_public_path__ + "q.no1.6a81a67f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/q.no1.jpg
// module id = Ew4i
// module chunks = 0